export const name =
`Product name is used to distinguish this product for management purposes.<br><br>
The packaging name is also valid.`;